import React from 'react'
import Heading from 'utils/Heading'
import TBBLink from 'utils/TBBLink'

const OneColumnText = ({blok}) => {
    return (
        <div className="my-12 lg:my-24">
            <div className="mx-auto px-6 lg:px-12 max-w-7xl">
                <div className="block lg:flex lg:flex-row gap-10">
                    <div className='w-full lg:w-2/3'>
                        <Heading size="h3" className="!mb-10 !text-4xl lg:!text-[64px] lg:!leading-[4rem]">
                            {blok.title}
                        </Heading>
                        <div className="grid grid-cols-1 sm:grid-cols-2 flex-row gap-y-3 gap-x-16 flex-wrap">
                            {blok.items && blok.items.map((item) => (
                                <TBBLink to={item.url.cached_url}>
                                    {item.title}
                                </TBBLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>          
        </div>
    )
};

export default OneColumnText;